import { useState } from "react";
import styles from "../styles/SaffView.module.css";
import StaffCurrent from "./StaffPages/StaffCurrent";
import StaffFormer from "./StaffPages/StaffFormer";
import StaffPositions from "./StaffPages/StaffPositions.jsx";

const SaffView = () => {
  const [activeTab, setActiveTab] = useState("Current");

  const tabs = [
    { id: "Current", label: "Текущие" },
    { id: "Former", label: "Бывшие" },
    { id: "Positions", label: "Должности" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "Current":
        return <StaffCurrent />;
      case "Former":
        return <StaffFormer />;
      case "Positions":
        return <StaffPositions />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${
              activeTab === tab.id ? styles.active : ""
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default SaffView;
